export default __webpack_public_path__ + "static/media/307.1eba843c.png";